import React from 'react';
import { TakipOzet, ilgiliMeta, tarihDurumu, tarihEtiketi } from './takipOrtak';
import './takip.css';

interface Props {
    takip: TakipOzet;
    ben: number;
    onAc: () => void;
    onDurum?: () => void;          // verilirse yuvarlak onay düğmesi tamamla/aç yapar
    kayitGizle?: boolean;          // kayıt sayfasında bağlı kayıt rozeti gereksiz
    kucuk?: boolean;
    surukle?: boolean;
}

const TakipKart: React.FC<Props> = ({ takip: t, ben, onAc, onDurum, kayitGizle, kucuk, surukle }) => {
    const meta = ilgiliMeta(t.ilgiliTur);
    const td = tarihDurumu(t);
    const atayan = t.olusturanKullaniciID != null && t.olusturanKullaniciID !== t.kullaniciID ? t.olusturanAdi : null;

    return (
        <div className={`tkp-kart${t.tamamlandi ? ' bitti' : ''}`} style={{ background: t.renk || '#f8f9fc', padding: kucuk ? '7px 10px' : undefined }} onClick={onAc}>
            {surukle && <span style={{ color: '#c4c9d4', fontSize: 13, marginTop: 3, cursor: 'grab' }}><i className="fas fa-grip-vertical"></i></span>}
            {onDurum ? (
                <button className={`tkp-onay${t.tamamlandi ? ' dolu' : ''}`} title={t.tamamlandi ? 'Yeniden aç' : 'Tamamlandı'}
                    onClick={e => { e.stopPropagation(); onDurum(); }}>
                    {t.tamamlandi && <i className="fas fa-check"></i>}
                </button>
            ) : (
                <span style={{ marginTop: 2, color: t.tamamlandi ? '#10b981' : '#9ca3af', fontSize: 14 }}>
                    <i className={`fas ${t.tamamlandi ? 'fa-check-circle' : t.ustTakipID ? 'fa-hand-paper' : 'fa-circle-notch'}`}></i>
                </span>
            )}
            <div className="tkp-kart-icerik">
                <div className="tkp-kart-baslik">{t.baslik}</div>
                {!kucuk && t.aciklama && <div className="tkp-kart-aciklama">{t.aciklama}</div>}
                <div className="tkp-kart-meta">
                    {t.gorevTarihi && (
                        <span className={`tkp-rozet ${t.tamamlandi ? 'notr' : td ?? 'notr'}`}>
                            <i className="fas fa-calendar-day"></i>{td === 'bugun' ? 'Bugün' : tarihEtiketi(t.gorevTarihi)}{t.baslangicSaati ? ` ${t.baslangicSaati}` : ''}
                        </span>
                    )}
                    {t.talepTuru && <span className="tkp-rozet talep"><i className="fas fa-hand-paper"></i>{t.talepTuru === 'SUREC' ? 'Süreç' : 'Bilgi'} talebi</span>}
                    {!kayitGizle && meta && (
                        <span className="tkp-rozet notr" title={`${meta.ad}: ${t.ilgiliBaslik ?? ''}`} style={{ maxWidth: 190 }}>
                            <i className={`fas ${meta.ikon}`} style={{ color: meta.renk }}></i>{t.ilgiliBaslik || meta.ad}
                        </span>
                    )}
                    {t.kullaniciID !== ben && t.kullaniciAdi && <span title="Sorumlu"><i className="fas fa-user"></i>{t.kullaniciAdi}</span>}
                    {atayan && t.kullaniciID === ben && <span title={t.ustTakipID ? 'Talep eden' : 'Atayan'}><i className="fas fa-user-tag"></i>{atayan}</span>}
                    {t.notSayisi > 0 && <span title="Not"><i className="fas fa-comment"></i>{t.notSayisi}</span>}
                    {t.dosyaSayisi > 0 && <span title="Dosya"><i className="fas fa-paperclip"></i>{t.dosyaSayisi}</span>}
                    {t.altTakipSayisi > 0 && (
                        <span title="Açık / toplam alt takip" style={{ color: t.acikAltTakipSayisi > 0 ? '#6d28d9' : undefined }}>
                            <i className="fas fa-sitemap"></i>{t.altTakipSayisi - t.acikAltTakipSayisi}/{t.altTakipSayisi}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TakipKart;
